import { useDeleteAccountModalStore } from "../../../js/stores/delete-account-modal-store";
import { DeleteAccountModal } from "./delete-account-modal";
import { Dialog, DialogContent } from "../shared/modal";

export const DeleteAccountWidget = ({popupButton, popupTitle, popupText, popupSubmit, popupCancel}) => {
  const isModalOpen = useDeleteAccountModalStore((state) => state.isModalOpen);
  const openModal = useDeleteAccountModalStore((state) => state.openModal);
  const closeModal = useDeleteAccountModalStore((state) => state.closeModal);
  const updateIsModalOpen = useDeleteAccountModalStore(
    (state) => state.updateIsModalOpen
  );

  const handleClick = () => {
    openModal();
  };

  return (
    <>
      <button
        type="button"
        className="delete-account__submit-button delete-account__submit-button--dark"
        onClick={handleClick}
      >
        {popupButton}
      </button>

      {isModalOpen && (
        <Dialog
          open={isModalOpen}
          onClose={closeModal}
          onOpenChange={updateIsModalOpen}
        >
          <DialogContent>
            <DeleteAccountModal
              closeModal={closeModal}
              popupTitle={popupTitle}
              popupText={popupText}
              popupSubmit={popupSubmit}
              popupCancel={popupCancel}

            />
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}